(async () => {
  const el = document.getElementById('ethical-commission-index')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/info/ethical-commission/index.vue'),
    },
  ]

  await clientRender({ components })
})()
